export default __webpack_public_path__ + "static/mine-free_medium_1-c90a93a1ddb75a7af24c11af4def974b.png";